interface Props {
  lines: string[];
}

/**
 * Quiet, non-interactive archival section that surfaces inside the debrief.
 * No charts. No timelines. No interaction.
 */
const PreviouslyObservedContinuity = ({ lines }: Props) => {
  if (!lines.length) return null;

  return (
    <section
      className="space-y-3 opacity-80"
      style={{ animation: "ambientFadeIn 1.2s ease-out both" }}
    >
      <p className="text-[9px] font-mono tracking-[0.42em] uppercase text-muted-foreground/45">
        Previously Observed Continuity
      </p>
      <div className="rounded-xl border border-border/30 bg-card/20 backdrop-blur-sm px-5 py-4 space-y-2.5">
        {lines.map((l, i) => (
          <p
            key={i}
            className="text-[12.5px] text-foreground/55 italic font-light leading-relaxed"
            style={{ animation: `ambientFadeIn 1.2s ease-out ${0.2 + i * 0.25}s both` }}
          >
            {l}
          </p>
        ))}
      </div>
      <p className="text-[9px] font-mono tracking-[0.32em] uppercase text-muted-foreground/30">
        Observed across earlier rehearsals · not a diagnosis
      </p>

      <style>{`
        @keyframes ambientFadeIn {
          from { opacity: 0; transform: translateY(4px); }
          to   { opacity: 0.85; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
};

export default PreviouslyObservedContinuity;
